import type { CarouselConfig } from '../ui/ymalProductsCarousel.types';

const ARROW_HIDE_THRESHOLD = 6;

/**
 * Generates carousel configuration based on product count
 * Configures responsive breakpoints and arrow visibility
 *
 * Requirements:
 * - Desktop (≥1200px): 6 products visible
 * - Tablet (560-1199px): 4 products visible
 * - Mobile (<560px): 2.5 products visible (shows partial next product)
 * - Arrows hidden if 6 or fewer products
 */
export function getCarouselConfig(productCount: number): CarouselConfig {
    return {
        perView: 6,
        gap: 32,
        disableArrows: productCount <= ARROW_HIDE_THRESHOLD,
        breakpoints: {
            1200: {
                perView: 4,
                gap: 24,
            },
            560: {
                perView: 2.5,
                gap: 8,
            },
        },
    };
}
